<div class="card-white">
  <ng-container *ngIf="formPrincipal">
    <div class="title-section">
      <h1 class="header-title">
        {{ modelRecived ? 'Editar Moratorios' : 'Agregar Moratorios' }}
      </h1>
    </div>

    <form [formGroup]="form" (submit)="modelRecived ? update(form.value) : create(form.value)" appPermissionControl="P142F0001">
      <div mat-dialog-content>
        <div class="titleFm" style="width: 200px">MORATORIOS</div>
        <div class="content-section">
          <div class="col-4">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Tasa</mat-label>
              <mat-select formControlName="claveTasa" appPermissionControl="P142K0001">
                <mat-option (click)="changeBoolean('tasas')"> <mat-icon>search</mat-icon>Buscar Tasa </mat-option>
                <mat-option *ngFor="let tasa of tasas" [value]="tasa.clave"> {{ tasa.clave }} | {{ tasa.descripcion }} </mat-option>
              </mat-select>
              <!-- <mat-error *ngIf="formValue('claveTasa')?.errors?.required"
        >Requerido</mat-error
        > -->
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Días de Gracia</mat-label>
              <input matInput placeholder="123" formControlName="diasGracia" type="number" appPermissionControl="P142K0002" />
            </mat-form-field>
          </div>
          <div class="line-break"></div>
          <div class="col-4">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Tasa</mat-label>
              <mat-select formControlName="claveTasa2" appPermissionControl="P142K0003">
                <mat-option (click)="changeBoolean('tasas2')"> <mat-icon>search</mat-icon>Buscar Tasa </mat-option>
                <mat-option *ngFor="let tasa of tasas" [value]="tasa.clave"> {{ tasa.clave }} | {{ tasa.descripcion }} </mat-option>
              </mat-select>
              <!-- <mat-error *ngIf="formValue('claveTasa')?.errors?.required"
                        >Requerido</mat-error
                        > -->
            </mat-form-field>
          </div>
          <div class="line-break"></div>
          <div class="col-4">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Calculados</mat-label>
              <mat-select formControlName="calculados" appPermissionControl="P142K0004">
                <mat-option [value]="1"> Al Pago </mat-option>
                <mat-option [value]="2"> Al Corte </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Aplicación Tasa</mat-label>
              <mat-select formControlName="aplicacionTasa" appPermissionControl="P142K0005">
                <mat-option [value]="1"> Variable </mat-option>
                <mat-option [value]="2"> Fija </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Aplica A</mat-label>
              <mat-select formControlName="aplicaOption" appPermissionControl="P142K0006">
                <mat-option [value]="1"> Cuota </mat-option>
                <mat-option [value]="2"> Capital </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="titleFm" style="width: 200px">IVA</div>
        <div class="content-section">
          <div class="col-3">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>IVA Moratorios</mat-label>
              <input matInput placeholder="123" formControlName="ivaMoratorios" type="number" appPermissionControl="P142K0007" />
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-select formControlName="ivaMoratoriosOption" appPermissionControl="P142K0008">
                <mat-option [value]="1"> Al Crear </mat-option>
                <mat-option [value]="2"> Al Pago </mat-option>
                <mat-option [value]="3"> No Calcular </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="titleFm" style="width: 200px">CALCULAR</div>
        <div class="content-section">
          <div class="col-3">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Fijo</mat-label>
              <input matInput placeholder="123" formControlName="fijo" type="number" appPermissionControl="P142K0009" />
            </mat-form-field>
          </div>
          <div class="line-break"></div>
          <div class="col-3">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Mínimo</mat-label>
              <input matInput placeholder="123" formControlName="minimo" type="number" appPermissionControl="P142K0010" />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="col-6" style="margin-top: 35px">
        <div mat-dialog-actions>
          <ng-container *ngIf="!loading"
            ><button class="btn-cancel" type="button" mat-raised-button (click)="close()" style="margin-right: 10px" appPermissionControl="P142B0001">
              <mat-icon>arrow_back</mat-icon>
              Atrás
            </button>
            <button class="btn-success" mat-raised-button color="accent" appPermissionControl="P142B0002">
              <mat-icon>save</mat-icon>
              {{ modelRecived ? 'Actualizar' : 'Guardar' }}
            </button>
          </ng-container>
          <button *ngIf="loading" class="botonGrandeFm" mat-raised-button color="accent" type="button" appPermissionControl="P142B0003">
            Cargando
            <mat-progress-bar mode="buffer"></mat-progress-bar>
          </button>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf="selectCocepto">
    <button mat-button color="accent" type="button" (click)="changeBoolean('form')" appPermissionControl="P142B0004"><mat-icon>west</mat-icon> Regresar</button>
    <app-select-concepto></app-select-concepto>
  </ng-container>

  <ng-container *ngIf="selectTasa">
    <button mat-button color="accent" type="button" (click)="changeBoolean('form')" appPermissionControl="P142B0005"><mat-icon>west</mat-icon> Regresar</button>
    <app-select-tasa></app-select-tasa>
  </ng-container>

  <ng-container *ngIf="selectTasa2">
    <button mat-button color="accent" type="button" (click)="changeBoolean('form')" appPermissionControl="P142B0006"><mat-icon>west</mat-icon> Regresar</button>
    <app-select-tasa></app-select-tasa>
  </ng-container>
</div>
